import React, { useEffect, useState } from 'react'
import {
    DashboardOutlined,
    UsergroupAddOutlined,
    QuestionCircleOutlined,
    QuestionOutlined,
    SettingOutlined,
    UserOutlined,
    FileOutlined,
    ApartmentOutlined,
    FileSearchOutlined
} from '@ant-design/icons';
import { Layout, Menu } from 'antd';
import SidebarFooter from './SidebarFooter';
import { useNavigate } from 'react-router-dom';
import Logo from './Logo';
import { useBasePath } from '../../hooks/useBasePath';
import SvgIcon from '../../const/SvgIcon';
import { ShowMenu } from '../../utils';
const { Sider } = Layout;

const Sidebar = ({ collapsed }) => {
    const navigate = useNavigate();
    const { openKey, selectKey } = useBasePath();

    return (
        <Sider
            className='layout_sidebar'
            collapsible
            collapsed={collapsed}
            width={240}
            trigger={!collapsed ? <SidebarFooter /> : null}
        >
            <Logo collapsed={collapsed} />
            <div className='sidebar_menus'>
                <Menu
                    mode="inline"
                    selectedKeys={selectKey}
                    defaultOpenKeys={openKey}
                    style={{ background: '#fecc4e' }}
                    items={[
                        // {
                        //     key: 'dashboard',
                        //     icon: < DashboardOutlined />,
                        //     label: 'Dashboard Management',
                        //     onClick: () => {
                        //         navigate("/")
                        //     }
                        // },
                        {
                            key: 'abdm',
                            icon: <FileOutlined />,
                            label: 'ABDM',
                            style: { display: ShowMenu(["ABDM"]) },
                            onClick: () => {
                                navigate("/abdm")
                            }
                        },
                        {
                            key: 'ticket-management',
                            icon: <FileOutlined />,
                            label: 'Ticket Management',
                            style: { display: ShowMenu(["Ticket Management"]) },
                            onClick: () => {
                                navigate("/ticket-management")
                            }
                        },
                       
                        {
                            key: 'user-management',
                            icon: < UsergroupAddOutlined />,
                            label: 'Users Management',
                            style: { display: ShowMenu(["Users", "Roles"]) },
                            children: [
                                {
                                    key: 'users',
                                    label: 'Users',
                                    icon: <UserOutlined />,
                                    style: { display: ShowMenu(["Users"]) },
                                    onClick: () => {
                                        navigate("/users")
                                    },
                                },
                                {
                                    key: 'roles',
                                    label: 'Roles',
                                    icon: <UserOutlined />,
                                    style: { display: ShowMenu(["Roles"]) },
                                    onClick: () => {
                                        navigate("/roles")
                                    },
                                }
                            ]
                        },
                    ]}
                />
            </div>
        </Sider>
    )
}

export default Sidebar